import styled from 'styled-components';
import { ChartDimensions, DEFAULT_MARGIN } from '@ardoq/graph';
import { TimeAxisRowSegmentLabelInfo } from '../types';
import {
  LabelColumnBackground,
  TickLabelRowContainer,
  XAxisLine,
  XAxisText,
  XAxisTickmark,
} from './styles';

const XAxisTickContainer = styled.div`
  display: inline;
`;

type XAxisLabelRowArgs = {
  rowHeight: number;
  dimensions: ChartDimensions;
  noVisibleTicksRowLabel: string | null;
  tickLabelsToDisplay: TimeAxisRowSegmentLabelInfo[];
};
const XAxisLabelRow = ({
  rowHeight,
  dimensions: {
    margin,
    chart: { width },
  },
  noVisibleTicksRowLabel,
  tickLabelsToDisplay,
}: XAxisLabelRowArgs) => (
  <TickLabelRowContainer
    style={{
      height: rowHeight,
    }}
  >
    <LabelColumnBackground
      style={{
        width: margin.left,
        height: rowHeight,
      }}
    />
    <XAxisTickmark
      style={{
        right: DEFAULT_MARGIN.right - 1,
      }}
    />
    {noVisibleTicksRowLabel ? (
      <XAxisText
        style={{
          left: margin.left + width * 0.5,
        }}
      >
        {noVisibleTicksRowLabel}
      </XAxisText>
    ) : null}
    {tickLabelsToDisplay.map(
      ({ previousTickLabel, tickPosition, currentTickLabel }) => {
        return (
          <XAxisTickContainer key={tickPosition}>
            {previousTickLabel ? (
              <XAxisText
                style={{
                  left: previousTickLabel.labelLeftPosition,
                }}
              >
                {previousTickLabel.labelText}
              </XAxisText>
            ) : null}
            <XAxisTickmark
              style={{
                left: tickPosition,
                top: 0,
                height: rowHeight,
              }}
            />
            {currentTickLabel ? (
              <XAxisText
                style={{
                  left: currentTickLabel.labelLeftPosition,
                }}
              >
                {currentTickLabel.labelText}
              </XAxisText>
            ) : null}
          </XAxisTickContainer>
        );
      }
    )}
    <XAxisLine
      style={{
        left: margin.left,
        top: rowHeight,
        width: width,
      }}
    />
  </TickLabelRowContainer>
);

export { XAxisLabelRow };
